/**
 * CouponEventHomeContainer
 * --
 */
import React from 'react';
import CouponEventHomePresenter from './CouponEventHomePresenter';
import { useDefaultShopDataStack } from 'store';
import { STORE_URL } from 'utils';
import dayjs from 'dayjs';

const CouponEventHomeContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== Store ===== */
  const { events } = useDefaultShopDataStack();

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const today = dayjs().unix();

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  const EventList = React.useMemo(() => {
    const newEventList = events
      .map((event) => {
        const isEnable =
          event.start_date > today
            ? 'PREV'
            : event.end_date < today
              ? 'END'
              : 'ING';

        return {
          ...event,
          src: event.thumbnail_url
            ? `${STORE_URL}/${event.thumbnail_url}`
            : null,
          description: event?.event_content?.replace(/<[^>]*>/g, ''),
          status: isEnable,
        };
      })
      ?.sort((a, b) => b?.created_at - a?.created_at)
      .filter((item) => {
        return item.type !== 'STORE';
      });

    return newEventList;
  }, [events, today]);

  /* ===== RENDER ===== */
  return (
    <>
      <CouponEventHomePresenter
        events={EventList}
        navigate={navigate}
        screenSize={screenSize}
      />
    </>
  );
};

export default CouponEventHomeContainer;
